<template>
  <div class="update-results">
    <h2>LANÇAR RESULTADOS</h2>
    <form @submit.prevent="submitResults">
      <div class="form-group">
        <label for="stage">Etapa:</label>
        <select v-model="selectedStageId" @change="fetchGroups" id="stage" required>
          <option v-for="stage in stages" :key="stage.id" :value="stage.id">
            {{ stage.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="group">Grupo:</label>
        <select v-model="selectedGroupId" @change="fetchPlayers" id="group" required>
          <option v-for="group in groups" :key="group.id" :value="group.id">
            {{ group.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="jogador">Jogador:</label>
        <select v-model="selectedPlayerId" @change="fetchGames" id="jogador" required>
          <option v-for="player in players" :key="player.id" :value="player.id">
            {{ player.User.fullName }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="Adversário">Adversário:</label>
        <select v-model="selectedGameId" @change="updateSelectedGame" id="game" required>
          <option v-for="game in games" :key="game.id" :value="game.id">
            {{ getAdversario(game) }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="status">Status:</label>
        <select v-model="gameStatus" id="status" required>
          <option value="Não realizado">Não Realizado</option>
          <option value="Realizado">Realizado</option>
          <option value="WO">WO</option>
        </select>
      </div>

      <div class="form-group">
        <label>Placar:</label>
        <div class="score-inputs">
          <div class="score-header">
            <span>{{ Jogador }}</span>
            <span>{{ Adversario }}</span>
          </div>
          <div class="score-row" v-for="(set, index) in score" :key="index">
            <span class="set-label">Set {{ index + 1 }}</span>
            <input v-model="set.jogador" type="number" :min="0" :max="getMax(index)" @input="validarLimite(set, 'jogador', index)" class="score-input" @focus="limparCampo(set, 'jogador')" required>
            <span>X</span>
            <input v-model="set.adversario" type="number" :min="0" :max="getMax(index)" @input="validarLimite(set, 'adversario', index)" class="score-input" @focus="limparCampo(set, 'adversario')" required>
          </div>
        </div>
      </div>


      <button type="button"
              class="save-button"
              @click="onSaveClick"
              :disabled="!(this.gameStatus === 'Realizado' || this.gameStatus === 'WO' || this.gameStatus === '')"
      >Salvar</button>
      <button type="button"
              class="editar-button"
              @click="showDeleteConfirmModal = true"
              :disabled="!(this.gameStatus === 'Realizado' || this.gameStatus === 'WO' || this.gameStatus === '')"
      >Excluir
      </button>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </form>
  </div>


  <div v-if="showConfirmModal" class="modal-overlay">
    <div class="modal-content">
      <h3>Confirmação de Sobrescrita</h3>
      <p>Este jogo já possui resultados. Deseja sobrescrevê-los?</p>
      <div class="button-conta">
        <button class="cancel" @click="confirmOverwrite(false)">Não</button>
        <button class="confirm" @click="confirmOverwrite(true)">Sim</button>
      </div>
    </div>
  </div>

  <div v-if="showDeleteConfirmModal" class="modal-overlay">
    <div class="modal-content">
      <h3>Confirmação de Exclusão</h3>
      <p>Tem certeza que deseja excluir este jogo? Esta ação não pode ser desfeita.</p>
      <div class="button-conta">
        <button class="cancel" @click="confirmDelete(false)">Não</button>
        <button class="confirm" @click="confirmDelete(true)">Sim</button>
      </div>
    </div>
  </div>
</template>

<script>
import stageService from '@/services/stageService';
import groupService from '@/services/groupService';
import gameService from '@/services/gameService';
import playerService from "@/services/playerService";

export default {
  name: 'UpdateResults',
  data() {
    return {
      stages: [],
      groups: [],
      players: [],
      games: [],
      selectedStageId: null,
      selectedGroupId: null,
      selectedPlayerId: null,
      selectedGameId: null,
      gameStatus: 'Não realizado',
      score: [
        {jogador: 0, adversario: 0},
        {jogador: 0, adversario: 0},
        {jogador: 0, adversario: 0},
      ],
      showConfirmModal: false,
      overwriteConfirmed: false,
      errorMessage: '',
      showDeleteConfirmModal: false,
    };
  },
  created() {
    this.fetchStages();
  },
  computed: {
    Jogador() {
      const selectedPlayer = this.players.find(player => player.id === this.selectedPlayerId);
      return selectedPlayer ? selectedPlayer.User.fullName : 'Jogador';
    },
    Adversario() {
      const selectedGame = this.games.find(game => game.id === this.selectedGameId);
      if (!selectedGame) {
        return 'Adversario';
      }

      if (selectedGame.player1.id === this.selectedPlayerId) {
        return selectedGame.player2.User.fullName;
      } else {
        return selectedGame.player1.User.fullName;
      }
    },
  },
  watch: {
    gameStatus(newStatus) {
      if (newStatus === 'WO') {
        this.setWOScore();
      }
    },
    selectedPlayerId(newPlayerId) {
      if (newPlayerId) {
        this.defaultValues();
      }
    },
    selectedGameId(newGameId) {
      if (newGameId) {
        this.fetchGames();
        this.defaultValues();
      }
    }
  },
  methods: {
    async fetchStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[this.stages.length - 1].id;
          await this.fetchGroups(this.selectedStageId);
        }
      } catch (error) {
        console.error('Erro ao buscar etapas', error);
      }
    },
    async fetchGroups() {
      try {
        const response = await groupService.getGroupsByStage(this.selectedStageId);
        this.groups = response.data;
      } catch (error) {
        console.error('Erro ao buscar groupos', error);
      }
    },
    async fetchPlayers() {
      try {
        const response = await groupService.getPlayersByGroup(this.selectedGroupId);
        this.players = response.data;
      } catch (error) {
        console.error('Erro ao carregar jogadores do grupo', error);
      }
    },
    async fetchGames() {
      try {
        const response = await gameService.getPlayerGamesByPlayerId(this.selectedStageId, this.selectedPlayerId);
        this.games = response.data;
        this.updateSelectedGame();
      } catch (error) {
        console.error('Erro ao carregar jogos do jogador selecionado', error);
      }
    },
    async submitResults() {
      const game = this.games.find(game => game.id === this.selectedGameId);

      if (!game) {
        alert('Jogo não encontrado');
      }

      const hasResults = game.status !== 'Não realizado';

      if (hasResults) {
        this.showConfirmModal = true;
      } else {
        await this.sendUpdatedGame();
      }


    },

    confirmOverwrite(confirm) {
      this.showConfirmModal = false;
      if (confirm) {
        this.overwriteConfirmed = true;
        this.sendUpdatedGame();
      }
    },

    async sendUpdatedGame() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      const updatedGame = {
        status: this.gameStatus,
        set1Player1: game.player1.id === this.selectedPlayerId ? this.score[0].jogador : this.score[0].adversario,
        set1Player2: game.player2.id === this.selectedPlayerId ? this.score[0].jogador : this.score[0].adversario,
        set2Player1: game.player1.id === this.selectedPlayerId ? this.score[1].jogador : this.score[1].adversario,
        set2Player2: game.player2.id === this.selectedPlayerId ? this.score[1].jogador : this.score[1].adversario,
        set3Player1: game.player1.id === this.selectedPlayerId ? this.score[2].jogador : this.score[2].adversario,
        set3Player2: game.player2.id === this.selectedPlayerId ? this.score[2].jogador : this.score[2].adversario,
      };

      const player1 = {
        stageId: this.selectedStageId,
        playerId: game.player1.id
      };

      const player2 = {
        stageId: this.selectedStageId,
        playerId: game.player2.id
      };



      try {
        await gameService.updateGame(this.selectedGameId, updatedGame);
        await playerService.updateAverage(player1);
        await playerService.updateAverage(player2);
        alert('Resultados salvos com sucesso');
        await this.fetchGames();
      } catch (error) {
        console.error("Erro ao salvar resultados:", error);
      }
    },
    updateSelectedGame() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game) {
        this.gameStatus = game.status;
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador) {
          this.score = [
            {jogador: game.set1Player1, adversario: game.set1Player2},
            {jogador: game.set2Player1, adversario: game.set2Player2},
            {jogador: game.set3Player1, adversario: game.set3Player2},
          ];
        } else {
          this.score = [
            {jogador: game.set1Player2, adversario: game.set1Player1},
            {jogador: game.set2Player2, adversario: game.set2Player1},
            {jogador: game.set3Player2, adversario: game.set3Player1},
          ];
        }
      }
    },
    setWOScore() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game) {
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador) {
          this.score = [
            {jogador: 6, adversario: 0},
            {jogador: 6, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
        } else {
          this.score = [
            {jogador: 6, adversario: 0},
            {jogador: 6, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
        }
      }
    },
    defaultValues() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game) {
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador) {
          this.score = [
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
          this.gameStatus = 'Não realizado';
        } else {
          this.score = [
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
          this.gameStatus = 'Não realizado';
        }
      }
    },
    getAdversario(game) {
      const eu = this.selectedPlayerId;
      if (eu === game.player1.id) {
        return game.player2.User.fullName;
      } else if (eu === game.player2.id) {
        return game.player1.User.fullName;
      } else {
        return false
      }
    },
    onSaveClick() {
      this.submitResults();
    },
    winner() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      let player1 = 0;
      let player2 = 0;
      let winner = null;

      if (game.set1Player1 > game.set1Player2) {
        player1 += 1;
      } else {
        player2 += 1;
      }

      if (game.set2Player1 > game.set2Player2) {
        player1 += 1;
      } else {
        player2 += 1;
      }

      if (game.set3Player1 > game.set3Player2) {
        player1 += 1;
      } else {
        player2 += 1;
      }

      if (player1 > player2) {
        winner = game.player1Id;
      } else {
        winner = game.player2Id;
      }

      return winner;

    },
    confirmDelete(confirm){
      this.showDeleteConfirmModal = false;

      if (confirm) {
        this.resetGameScore();
      }
    },
    async resetGameScore() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (!game) {
        alert('Jogo não encontrado');
        return;
      }

      const vencedor = this.winner();
      const resetInDTO = {
        vencedor: vencedor,
        player1Id: game.player1Id,
        player2Id: game.player2Id,
        status: game.status,
        set1Player1: game.set1Player1,
        set1Player2: game.set1Player2,
        set2Player1: game.set2Player1,
        set2Player2: game.set2Player2,
        set3Player1: game.set3Player1,
        set3Player2: game.set3Player2,
      };


      try{
        await gameService.updateStatistics(game.id,resetInDTO);
        alert("Jogo excluído com sucesso!");
        this.defaultValues();
        await this.fetchGames();
      }catch(error){
        console.error(error);
        alert('Erro ao excluir jogo. Tente novamente!')
      }
    },
    getMax(index){
      if (index === 0 || index === 1){
        return 7;
      }
      if (index === 2){
        return 30;
      }
    },
    limparCampo(set, campo){
      if(set[campo] === 0 || set[campo] === null){
        set[campo] = '';
      }
    },
    validarLimite(set, campo, index){
      const max = this.getMax(index);

      if (set[campo] > max) {
        set[campo] = max;
      }

      if (set[campo] < 0) {
        set[campo] = 0;
      }
    }
  }
}
</script>

<style scoped>
.update-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: #FFF;
  color: black;
  border-radius: 10px;
  max-width: 600px;
  width: 80%;
  margin: auto;
  box-sizing: border-box;
}

.update-results h2 {
  margin-bottom: 1.5rem;
  color: black;
}

.form-group {
  margin-bottom: 1rem;
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: black;
}

.form-group select,
.form-group input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  background-color: white;
  color: black;
}

.score-inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 1rem;
  border-radius: 10px;
  color: black;
  margin-bottom: 1rem;
  width: 100%;
}

.score-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.score-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  gap: 8px;
  width: 100%;
}

.score-row .set-label {
  width: 20%;
  text-align: right;
  margin-right: 0.5rem;
  color: black;
}

.score-row input {
  width: 20%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.score-row span {
  text-align: center;
  color: black;
  width: 10%;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"]{
  -moz-appearance: textfield;
  appearance: textfield;
}

.save-button {
  padding: 0.75rem 1.5rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.save-button:hover {
  background-color: #218838;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 1001;
}

.modal-content h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.modal-content p {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: #555;
}

.modal-content {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.modal-content button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
}

.modal-content button:hover {
  opacity: 0.9;
}

.modal-content button.confirm {
  background-color: #28a745;
  color: #fff;
}

.modal-content button.cancel {
  background-color: #dc3545;
  color: #fff;
}

.error-message {
  color: red;
  margin-top: 1rem;
  text-align: center;
}

.editar-button {
  padding: 0.75rem 1.5rem;
  margin-left: 0.7rem;
  background-color: red;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .form-group {
    width: 90%;
  }

  .score-header,
  .score-row {
    flex-direction: row;
    align-items: center;
  }

  .score-row .set-label,
  .score-input,
  .score-row span {
    width: 100%;
    text-align: center;
    margin: 0.25rem 0;
  }

  .modal-content {
    max-width: 80%;
    padding: 1.5rem;
  }

  .modal-content h3 {
    font-size: 1.25rem;
  }

  .modal-content p {
    font-size: 0.95rem;
  }

  .modal-content button {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 425px) {
  .form-group {
    width: 100%;
  }

  .score-header,
  .score-row {
    flex-direction: row;
    align-items: center;
  }

  .score-row .set-label,
  .score-input,
  .score-row span {
    width: 100%;
    text-align: center;
    margin: 0.25rem 0;
  }

  .modal-content {
    max-width: 90%;
    padding: 1rem;
  }

  .modal-content h3 {
    font-size: 1rem;
  }

  .modal-content p {
    font-size: 0.85rem;
  }

  .modal-content button {
    font-size: 0.85rem;
    padding: 0.5rem;
  }

}
</style>
